import { render, staticRenderFns } from "./AvatarPlug.vue?vue&type=template&id=de957740&scoped=true&"
import script from "./AvatarPlug.vue?vue&type=script&lang=js&"
export * from "./AvatarPlug.vue?vue&type=script&lang=js&"
import style0 from "./AvatarPlug.vue?vue&type=style&index=0&id=de957740&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de957740",
  null
  
)

export default component.exports